import type { MCPServer } from "@/types";

const STORAGE_KEY = "chatmcp:servers";

export const loadServers = (): MCPServer[] | null => {
  if (typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as MCPServer[]) : null;
  } catch {
    return null;
  }
};

export const saveServers = (servers: MCPServer[]) => {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(servers));
  } catch {
    // ignore write errors
  }
};
